<template>
<div>
    <BreadCrumb class="bread" :breads="['商品管理','统一调价']"></BreadCrumb>
    <div class="wrap">
        <div class="header">
            <span class="nameFt">统一调价</span>
        </div>
    </div>
    <div class="submit-form">
        <el-form :model="search" :inline="true" size="small" label-width="80px">
            <div class="submit-form__search">
                <el-form-item label="时间范围">
                    <el-date-picker v-model="time" size="small" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="getDataTime">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="名称">
                    <el-input v-model="search.change_name" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="应用范围">
                    <el-select v-model="search.terminal_range">
                        <el-option label="全部设备" :value="1"></el-option>
                        <el-option label="指定设备" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品范围">
                    <el-select v-model="search.items_range">
                        <el-option label="全部商品" :value="1"></el-option>
                        <el-option label="指定商品" :value="2"></el-option>
                    </el-select>
                </el-form-item>
            </div>
            <div class="submit-form__operate">
                <el-form-item>
                    <el-button class="queryBtn" size="small" type="primary" @click="searchForm">查询</el-button>
                    <el-button class="queryBtn" size="small" type="primary" @click="reset">重置</el-button>
                </el-form-item>
            </div>
        </el-form>
    </div>
    <div class="operate-con">
        <el-button size="small" @click="openAdd()">新增</el-button>
    </div>
    <div class="table-con">
        <el-table :data="tableList" stripe v-loading="loading">
            <el-table-column label="序号" type="index" align="center" :index="indexMethod"></el-table-column>
            <el-table-column label="名称" align="center" prop="change_name"></el-table-column>
            <el-table-column label="应用范围" align="center">
                <template slot-scope="scope">
                    <div v-if="scope.row.terminal_range==1">全部设备</div>
                    <div v-if="scope.row.terminal_range==2">指定设备</div>
                </template>
            </el-table-column>
            <el-table-column label="商品范围" align="center" >
                <template slot-scope="scope">
                    <div v-if="scope.row.items_range==1">全部商品</div>
                    <div v-if="scope.row.items_range==2">指定商品</div>
                </template>
            </el-table-column>
            <el-table-column label="价格调整" align="center" >
                <template slot-scope="scope">
                    <div v-if="scope.row.price_range==1">指定价格</div>
                    <div v-if="scope.row.price_range==2">全部上调</div>
                    <div v-if="scope.row.price_range==3">全部下调</div>
                </template>
            </el-table-column>

            <!-- <el-table-column label="应用范围" align="center" prop="items_range"></el-table-column> -->
            <el-table-column label="调整比例(%)" align="center" prop="change_ratio"></el-table-column>
            <el-table-column label="描述" align="center" prop="change_remark"></el-table-column>
            <el-table-column label="操作" align="center" prop="change_remark">
                <template slot-scope="scope">
                      <el-button title="详情" size="small" type="primary" @click="openView(scope.row.id)">详情</el-button>
                </template>
            </el-table-column>

        </el-table>
    </div>
    <div class="paginationWrap"> 
        <el-pagination @current-change="handleCurrentChange" :page-size="pageSize" :current-page="pageNum" :layout="pageLayout" :total="total">
        </el-pagination>
    </div>
</div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import apis from "@/config/apis";
import alert from "@/plugins/alert";
import listMixin from "@/mixins/list";
export default {
    data() {
        return {
            search: {
                change_name: "",
                start_time: "", 
                end_time: "",
                terminal_range: "",
                items_range:"",
            },
            pagination: {},
            tableData: [],
            time: [],
        };

    },
    components: {
        BreadCrumb
    },
    computed: {
        time: {
            get() {
                return [this.search.start_time, this.search.end_time];
            },
            set(data) {
                if (data) {
                    this.search.start_time = data[0];
                    this.search.end_time = data[1];
                } else {
                    this.search.start_time = "";
                    this.search.end_time = "";
                }
            },
        },
    },
    mixins: [listMixin],
    created() {
        this.search = Object.assign(this.search, this.$route.query);
        this.getData();
    },
    methods: {
        getData() {
            this.getTableData(apis.price_change, "get", this.search);
        },
        getDataTime(data){
              if (data) {
                    this.search.start_time = data[0];
                    this.search.end_time = data[1];
                } else {
                    this.search.start_time = "";
                    this.search.end_time = "";
                }

        },
        searchForm() {
            this.search.page_index = 1;
            this.getData();
        },
        reset() {
            this.search.change_name= "",
            this.search.start_time= "",
            this.search.end_time= "",
            this.search.terminal_range= "";
            this.search.items_range = "";
            this.search.page_index = 1;
            this.time = [];
            this.getData();
        },
        //打开模板详情
        openView(id) {
            this.$router.push({
                name: "addPrice",
                query: {
                    id: id,
                    operateType: "modelLook"
                }
            });
        },
        openAdd() {
            this.$router.push({
                name: "addPrice",
                // query: {
                //   operateType: "modelAdd"
                // }
            });
        },
        openUpdate(id) {
            this.$router.push({
                name: "addPrice",
                query: {
                    id: id,
                }
            });
        },
        deleteItem(id) {
            alert.deleteAlert().then(res => {
                this.$axios
                    .delete(apis.template_delete, {
                        params: {
                            id: id
                        }
                    })
                    .then(res => {
                        if (res.data.code === 200) {
                            this.$message({
                                type: "success",
                                message: "删除成功"
                            });
                            this.getData();
                        } else {
                            this.$message({
                                type: "error",
                                message: res.data.msg
                            });
                        }
                    });
            });
        }
    }
};
</script>

<style lang="scss" scoped>
</style>
